export default "__VITE_ASSET__a76c5708__"